import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Drawer,
} from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import Slidemenu from '../../components/admin/adminSlidemenu.tsx';
import AdminHeader from '../../components/admin/adminHeader.tsx';

const SmsSettings = () => {
  // State variables for form
  const [host, setHost] = useState('');
  const [path, setPath] = useState('');
  const [username, setUsername] = useState('');
  const [hash, setHash] = useState('');
  const [sender, setSender] = useState('');

  // Drawer state
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Clear form
  const handleClear = () => {
    setHost('');
    setPath('');
    setUsername('');
    setHash('');
    setSender('');
  };

  // Save handler
  const handleSave = () => {
    alert('Settings saved!');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, height: '100vh' }}>
      
      {/* Sidebar for desktop */}
      <Box sx={{ width: { xs: '0px', md: '250px' }, flexShrink: 0, display: { xs: 'none', md: 'block' } }}>
        <Slidemenu mobileOpen={false} onToggle={function (): void {
          throw new Error("Function not implemented.");
        } } />
      </Box>
      
      {/* Drawer for mobile */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { width: 250 },
        }}
      >
        <Slidemenu onClose={handleDrawerToggle} />
      </Drawer>

      {/* Main content */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Header with menu toggle on mobile7 */}
        <AdminHeader onToggleMenu={handleDrawerToggle} />

        {/* Content area */}
        <Box
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            p: 2,
            backgroundColor: '#f5f5f5',
            position: 'relative',
          }}
        >
          {/* Top right icon */}
          <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
            <MoreVert />
          </Box>

          {/* Title */}
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>SMS Settings</Typography>

          {/* Responsive formxslk,sn container */}
          <Box
            sx={{
              maxWidth: { xs: '84%', sm: 600 },
              width: '100%',
              bgcolor: 'background.paper',
              p: 3,
              borderRadius: 2,
              boxShadow: 3,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              mx: 'auto',
            }}
          >
            {/* SMTP Fields */}
            <TextField
              label="Host"
              value={host}
              onChange={(e) => setHost(e.target.value)}
              fullWidth
              size="small"
            />
            <TextField
              label="Path"
              value={path}
              onChange={(e) => setPath(e.target.value)}
              fullWidth
              size="small"
            />
            <TextField
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              fullWidth
              size="small"
            />
            <TextField
              label="Hash"
              value={hash}
              onChange={(e) => setHash(e.target.value)}
              fullWidth
              size="small"
            />
            <TextField
              label="Sender"
              value={sender}
              onChange={(e) => setSender(e.target.value)}
              fullWidth
              size="small"
            />

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Button variant="outlined" onClick={handleClear}>Clear</Button>
              <Button variant="contained" onClick={handleSave}>Save</Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SmsSettings;